import request from '@/utils/request'

/**
 * 获取新闻列表（分页）
 * @param {Object} params - 查询参数 { page, pageSize, keyword }
 * @returns {Promise}
 */
export function getNewsList(params) {
  return request({
    url: '/news/website/all',
    method: 'get',
    params
  })
}

/**
 * 获取新闻详情
 * @param {number|string} id - 新闻ID
 * @returns {Promise}
 */
export function getNewsDetail(id) {
  return request({
    url: `/news/website/info/${id}`,
    method: 'get'
  })
}


/**
 * 获取热门新闻
 * @param {Object} params - 查询参数 { limit }
 * @returns {Promise}
 */
export function getHotNews(params) {
  return request({
    url: '/news/website/hot/list',
    method: 'get',
    params
  })
}

/**
 * 获取技术专栏新闻
 * @param {Object} params - 查询参数 { limit }
 * @returns {Promise}
 */
export function getTechNews(params) {
  return request({
    url: '/news/website/tech/list',
    method: 'get',
    params
  })
}
